import React from 'react';
import configData from '../../../temp/config';
import { withTranslation } from 'react-i18next';

const OvulationStory = (props) => {

    return (

        <div className="ovulation-story-container">
            <div className="ovulation-story-wrapper">
                <div className="ovulation-story-heading">
                    <div className="ovulation-story-heading-text">{props.t('OvulationCalculator_OvulationStoryTitle')}</div>
                </div>
                {props.ovulationStory.map((item, index) => {
                    return <div key={index} className={index === props.ovulationStory.length - 1 ? 'story-steps-wrapper last-story-step' : "story-steps-wrapper"}>
                        <div className="story-steps-icon">
                            <img className="story-steps-img" src={`${configData.sitecoreApiHost}${item.fields.image.value.src}`} alt={item.fields.image.value.alt} />
                            <div className="vertical-bar"></div>
                        </div>
                        <div className="story-steps-detail">
                            <div className="story-heading">
                                <div className="story-heading-text">{item.fields.Title.value}</div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <p className="card-body-text">{item.fields.Description.value}</p>
                                    <a href={item.fields.MoreLink.value.href} className="know-more-story">{item.fields.MoreLink.value.text}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </div>
    )
}



export default withTranslation()(OvulationStory);